export const ROLE_NAME_COMPONENT_NAME: string = 'roleName'
export const DESCRIPTION_COMPONENT_NAME: string = 'description'
